import { Dialog } from "primereact/dialog";
import { ProgressBar } from "primereact/progressbar";
import { useEffect } from "react";
import { supahubSso } from "../../api/routes";

export const SupahubSso = () => {
  useEffect(() => {
    supahubSso().then((jwtPayload) => {
      const redirectUrl = `https://pantheon-ai.supahub.com/api/auth/sso?jwt=${jwtPayload}&redirectTo=https://pantheon-ai.supahub.com/`;
      window.location.href = redirectUrl;
    });
  }, []);

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Dialog
        visible={true}
        onHide={() => {}}
        header="Authenticating..."
        closable={false}
        style={{ width: "600px", height: "200px" }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ProgressBar
            mode="indeterminate"
            style={{ height: "6px", width: "100%" }}
          />
        </div>
      </Dialog>
    </div>
  );
};
